module.exports = __webpack_public_path__ + "static/media/rentRates-1bedroom-condoApt-02.98a251a5.png";